import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QField from "../field/QField.js";
import QChip from "../chip/QChip.js";
import { FormFieldMixin } from "../../mixins/form.js";
import FileMixin, { FileValueMixin } from "../../mixins/file.js";
import { isSSR } from "../../plugins/Platform";
import { humanStorageSize } from "../../utils/format.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'QFile',
  mixins: [QField, FileMixin, FormFieldMixin, FileValueMixin],
  props: {
    /* SSR does not know about File & FileList */
    value: isSSR === true ? {} : [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  data: function data() {
    return {
      dnd: false
    };
  },
  computed: {
    innerValue: function innerValue() {
      return Object(this.value) === this.value ? 'length' in this.value ? Array.from(this.value) : [this.value] : [];
    },
    selectedString: function selectedString() {
      return this.innerValue.map(function (file) {
        return file.name;
      }).join(', ');
    },
    totalSize: function totalSize() {
      return humanStorageSize(this.innerValue.reduce(function (acc, file) {
        return acc + file.size;
      }, 0));
    },
    counterProps: function counterProps() {
      return {
        totalSize: this.totalSize,
        filesNumber: this.innerValue.length,
        maxFiles: this.maxFiles
      };
    },
    computedCounter: function computedCounter() {
      if (this.counterLabel !== void 0) {
        return this.counterLabel(this.counterProps);
      }

      var max = this.maxFiles;
      return "".concat(this.innerValue.length).concat(max !== void 0 ? ' / ' + max : '', " (").concat(this.totalSize, ")");
    },
    inputAttrs: function inputAttrs() {
      return _objectSpread(_objectSpread({
        tabindex: -1,
        type: 'file',
        title: '',
        // try to remove default tooltip,
        accept: this.accept,
        capture: this.capture,
        name: this.nameProp
      }, this.qAttrs), {}, {
        id: this.targetUid,
        disabled: this.editable !== true
      });
    },
    isAppending: function isAppending() {
      return this.multiple === true && this.append === true;
    }
  },
  methods: {
    removeAtIndex: function removeAtIndex(index) {
      var files = this.innerValue.slice();
      files.splice(index, 1);

      this.__emitValue(files);
    },
    removeFile: function removeFile(file) {
      var index = this.innerValue.findIndex(file);

      if (index > -1) {
        this.removeAtIndex(index);
      }
    },
    __emitValue: function __emitValue(files) {
      this.$emit('input', this.multiple === true ? files : files[0]);
    },
    __onKeyup: function __onKeyup(e) {
      // only on ENTER
      e.keyCode === 13 && this.pickFiles(e);
    },
    __getFileInput: function __getFileInput() {
      return this.$refs.input;
    },
    __addFiles: function __addFiles(e, fileList) {
      var files = this.__processFiles(e, fileList, this.innerValue, this.isAppending);

      files !== void 0 && this.__emitValue(this.isAppending === true ? this.innerValue.concat(files) : files);
    },
    __getControl: function __getControl(h) {
      var data = {
        ref: 'target',
        staticClass: 'q-field__native row items-center cursor-pointer',
        attrs: {
          tabindex: this.tabindex
        }
      };

      if (this.editable === true) {
        data.on = cache(this, 'native', {
          dragover: this.__onDragOver,
          keyup: this.__onKeyup
        });
      }

      return h('div', data, [this.__getInput(h)].concat(this.__getSelection(h)));
    },
    __getControlChild: function __getControlChild(h) {
      return this.__getDnd(h, 'file');
    },
    __getSelection: function __getSelection(h) {
      var _this = this;

      if (this.$scopedSlots.file !== void 0) {
        return this.innerValue.map(function (file, index) {
          return _this.$scopedSlots.file({
            index: index,
            file: file,
            ref: _this
          });
        });
      }

      if (this.$scopedSlots.selected !== void 0) {
        return this.$scopedSlots.selected({
          files: this.innerValue,
          ref: this
        });
      }

      if (this.useChips === true) {
        return this.innerValue.map(function (file, i) {
          return h(QChip, {
            key: 'file-' + i,
            props: {
              removable: _this.editable,
              dense: true,
              textColor: _this.color,
              tabindex: _this.tabindex
            },
            on: cache(_this, 'rem#' + i, {
              remove: function remove() {
                _this.removeAtIndex(i);
              }
            })
          }, [h('span', {
            staticClass: 'ellipsis',
            domProps: {
              textContent: file.name
            }
          })]);
        });
      }

      return [h('div', {
        style: this.inputStyle,
        class: this.inputClass,
        domProps: {
          textContent: this.displayValue !== void 0 ? this.displayValue : this.selectedString
        }
      })];
    },
    __getInput: function __getInput(h) {
      var data = {
        ref: 'input',
        staticClass: 'q-field__input fit absolute-full cursor-pointer',
        attrs: this.inputAttrs,
        domProps: this.formDomProps,
        on: cache(this, 'input', {
          change: this.__addFiles
        })
      };

      if (this.multiple === true) {
        data.attrs.multiple = true;
      }

      return h('input', data);
    }
  },
  created: function created() {
    this.fieldClass = 'q-file q-field--auto-height'; // necessary for QField's clearable
    // and FileValueMixin

    this.type = 'file';
  }
});